export const MENU_LINKS = [
  { href: '/blogs', title: 'The blog' },
  { href: '/#app-info', title: 'App Info' },
  { href: '/#functionality', title: 'Functionality' },
  { href: '/#how-it-works', title: 'How it Works' },
  { href: '/#faq', title: 'FAQ' },
  { href: '/#team', title: 'Team' },
  { href: '/#about-us', title: 'About Us' },
];

export const AIKA_LOGO_SQUARE = '/images/icon.png';
